import { endpointHandler } from '../../endpoints';
const { acceptPrivacyNoticeEndpoint } = endpointHandler();

export const acceptPrivacyNoticeAPI = (data, reqConfig, urlVar) => {
  return acceptPrivacyNoticeEndpoint.post(data, reqConfig, urlVar);
};
